<template>
  <div>
    <div v-if="showChrome" id="overlay" :class="{ active: isMenuOpen }" @click="$emit('close-menu')"></div>
    <div v-if="showChrome" class="mobile-menu" :class="{ active: isMenuOpen }" @click="$emit('close-menu')">
      <div class="mobile-menu__header">
        <div class="header-logos">
          <a href="https://tkmistral.ru/brands/mistral/" target="_blank">
            <img src="@/assets/img/ui/logo.svg" alt="">
          </a>
        </div>
        <div class="nav-icon" :class="{ active: isMenuOpen }" @click.stop="$emit('toggle-menu')">
          <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
            <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="white"/>
            <path d="M32.5024 17.5002L17.502 32.5007M17.502 17.5002L32.5024 32.5007" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>
      </div>
      <div class="mobile-menu__content">
        <nav class="nav">
          <a
            v-for="item in navItems"
            :key="item.id"
            href="#"
            :class="{ 'is-active': activeSection === item.id }"
            @click.prevent="$emit('nav-click', `#${item.id}`)"
          >
            {{ item.name }}
          </a>
        </nav>
      </div>
      <div class="mobile-menu__controls">
        <template v-if="showGuestUploadInMobile && !user">
          <button type="button" class="button header-btn header-btn--check" @click="$emit('guest-upload')">
            Загрузить чек
          </button>
          <button type="button" class="button header-btn header-btn--user" @click="$emit('open-login')">
            Войти
          </button>
        </template>

        <template v-else-if="!user">
          <button type="button" class="button header-btn header-btn--user" @click="$emit('open-login')">
            Войти
          </button>
        </template>

        <template v-else>
          <button
            type="button"
            :disabled="uploadDisabled"
            class="button header-btn header-btn--check"
            @click="$emit('auth-upload')"
          >
            Загрузить чек
          </button>
          <button type="button" class="button header-btn header-btn--user" @click="$emit('account')">
            {{ user.first_name }} {{ user.last_name_initial }}.
          </button>
          <button type="button" class="button header-btn header-btn--logout" @click="$emit('logout')">
            <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M12 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H12M21.3333 22.6667L28 16M28 16L21.3333 9.33333M28 16H12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
          </button>
        </template>
      </div>
    </div>
    <header class="header" id="header" :class="headerClass">
      <div class="container">
        <div class="header-wrap">
          <div class="header-logos">
            <a href="https://tkmistral.ru/brands/mistral/" target="_blank">
              <img src="@/assets/img/ui/logo.svg" alt="">
              <img src="@/assets/img/ui/logo-dark.svg" alt="" class="account-logo">
            </a>
          </div>
          <nav v-if="showChrome" class="header-nav">
            <a
              v-for="item in navItems"
              :key="item.id"
              href="#"
              :class="{ 'is-active': activeSection === item.id }"
              @click.prevent="$emit('nav-click', `#${item.id}`)"
            >
              {{ item.name }}
            </a>
          </nav>
          <div v-if="showChrome" class="header-user">
            <template v-if="!user">
              <button
                v-if="showGuestUploadOnDesktop"
                type="button"
                class="button header-btn header-btn--check"
                @click="$emit('guest-upload')"
              >
                Загрузить чек
              </button>
              <button type="button" class="button header-btn header-btn--user" @click="$emit('open-login')">
                Войти
              </button>
            </template>
            <template v-else>
              <button
                type="button"
                :disabled="uploadDisabled"
                class="button header-btn header-btn--check"
                @click="$emit('auth-upload')"
              >
                Загрузить чек
              </button>
              <button type="button" class="button header-btn header-btn--user" @click="$emit('account')">
                {{ user.first_name }} {{ user.last_name_initial }}.
              </button>
              <button type="button" class="button header-btn header-btn--logout" @click="$emit('logout')">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 28H6.66667C5.95942 28 5.28115 27.719 4.78105 27.219C4.28095 26.7189 4 26.0406 4 25.3333V6.66667C4 5.95942 4.28095 5.28115 4.78105 4.78105C5.28115 4.28095 5.95942 4 6.66667 4H12M21.3333 22.6667L28 16M28 16L21.3333 9.33333M28 16H12" stroke="white" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </template>
          </div>
          <div v-if="showChrome" class="header-mobile">
            <div class="nav-icon" :class="{ active: isMenuOpen }" @click.stop="$emit('toggle-menu')">
              <svg width="50" height="50" viewBox="0 0 50 50" fill="none" xmlns="http://www.w3.org/2000/svg">
                <rect x="0.5" y="0.5" width="49" height="49" rx="24.5" stroke="white"/>
                <path d="M13.752 21.2498H36.2527M13.752 28.7501H30.6275" stroke="white" stroke-width="1.87506" stroke-linecap="round" stroke-linejoin="round"/>
              </svg>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
export default {
  name: 'SiteHeader',
  props: {
    user: {
      type: Object,
      default: null,
    },
    /** Скрыть оверлей/меню/навигацию (например, Telegram-страница) */
    showChrome: {
      type: Boolean,
      default: true,
    },
    navItems: {
      type: Array,
      default: () => [],
    },
    activeSection: {
      type: [String, Number],
      default: '',
    },
    isHeaderScrolled: {
      type: Boolean,
      default: false,
    },
    /** Доп. класс is-scrolled (например, блокировка how на главной) */
    headerScrolledExtra: {
      type: Boolean,
      default: false,
    },
    isMenuOpen: {
      type: Boolean,
      default: false,
    },
    /** На главной в мобильном меню у гостя показываем «Загрузить чек» */
    showGuestUploadInMobile: {
      type: Boolean,
      default: false,
    },
    uploadDisabled: {
      type: Boolean,
      default: false,
    },
    /** Для главной: у гостя в шапке две кнопки. В ЛК / 404 — только «Войти». */
    showGuestUploadOnDesktop: {
      type: Boolean,
      default: true,
    },
  },
  emits: [
    'toggle-menu',
    'close-menu',
    'nav-click',
    'logo-click',
    'open-login',
    'guest-upload',
    'auth-upload',
    'account',
    'logout',
  ],
  computed: {
    headerClass() {
      return {
        'is-scrolled': this.isHeaderScrolled || this.headerScrolledExtra,
      };
    },
  },
};
</script>
